import { AuthenticationContext } from 'react-adal';
import queryString from 'query-string';
import _extend from 'lodash/extend';

import { API_ROOT } from './configApi';
import { CLIENT_ID } from './configClientId';

const FORM_POST = 'form_post';

const addQuery = (uri, queryToAdd) => {
  const {url, query} = queryString.parseUrl(uri);
  const newQuery = queryString.stringify(_extend(query, queryToAdd));

  return `${url}?${newQuery}`;
};

export const adalConfig = {
  instance: 'https://identity.airwis.com/',
  tenant: 'adfs',
  clientId: `${CLIENT_ID}`,
  redirectUri: `${API_ROOT}authentication/login`,
  endpoints: {
    api: `${CLIENT_ID}`,
  },
  modifyRenewUrl: urlNavigate => addQuery(urlNavigate, {response_mode: FORM_POST}),
  displayCall: urlNavigate => {
    window.location.replace(addQuery(urlNavigate, {response_mode: FORM_POST}));
  },
};

export const authContext = new AuthenticationContext(adalConfig);

window.Logging.level = 3;
window.Logging.log = message => console.log(`[ADAL] ${message}`);

export const authenticateToken = () => !!authContext.getCachedUser();
